'use client';

import { useLocale } from 'next-intl';
import { useEffect, useRef } from 'react';
import { useIntersection } from 'react-use';

interface ArticleScrollObserverProps {
  articlePath: string;
  articleTitle: string;
}

export default function ArticleScrollObserver({
  articlePath,
  articleTitle,
}: ArticleScrollObserverProps) {
  const locale = useLocale();
  const intersectionRef = useRef<HTMLDivElement>(null);

  const intersection = useIntersection(intersectionRef, {
    root: null,
    rootMargin: '0px',
    threshold: 1,
  });

  useEffect(() => {
    if (!intersection || intersection.intersectionRatio < 1) return;

    document.title = articleTitle;
    window.history.replaceState(null, articleTitle, `/${locale}${articlePath}`);
  }, [intersection?.intersectionRatio]);

  return <div className="h-0.5 w-full" ref={intersectionRef} />;
}
